import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SanitizationService {
  constructor(private sanitizer: DomSanitizer) {}

  public sanitizeText(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    let textValue: string;

    if (typeof value === 'string') {
      textValue = value;
    } else if (typeof value === 'number' || typeof value === 'boolean') {
      textValue = String(value);
    } else if (typeof value === 'object') {
      try {
        textValue = JSON.stringify(value);
      } catch {
        textValue = '';
      }
    } else {
      textValue = String(value);
    }

    const textarea = document.createElement('textarea');
    textarea.textContent = textValue;
    return textarea.innerHTML;
  }

  public sanitizeHtml(htmlContent: string): SafeHtml {
    return this.sanitizer.sanitize(1, htmlContent) || '';
  }

  public bypassSanitize(htmlContent: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }
}
